import React from "react";
import "./addCataloguePackageFeatureDetails.css";
import Select from "react-select";
import { FormControl } from "react-bootstrap";
import CustomCheckbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const CataloguePackageFeatureDetailsForm = (props) => {
  const {
    featureDetails,
    setFeatureDetails,
    addSpecialtyRow,
    onChangeTags,
    onChangeTier,
    tagListOption,
    couponList,
    groupData,
    specialtyListOption,
    doctorListOption,
    onSpecialityChange,
    onCallChange,
    handleAllCheckedFreeDelivery,
    deliveryWelcomeNote,
    setDeliveryWelcomeNote,
    noOfFreeDelivery,
    setNoOfFreeDelivery,
    noOfFreeValue,
    setNoOfFreeValue,
    tags,
    selectedTiers,
    selectedTags,
    setSelectedTags,
    setSelectedTiers,
    onCouponAdd,
    onRemoveCoupon,
    onGroupAdd,
    onGroupRemove,
    updateClaimField,
    updatePolicyField,
    toggleClaimCheckbox,
    onDoctorChange,
    onDoctorCallChange,
    addDoctorRow,
    removeDoctorRow,
    removeSpecialtyRow,
    processing,
    packageNameError,
    packageDurationError,
    packagePriceError,
    countryError,
    claimValueError,
    onCallUnlimitedChange,
    ipdClaimValueError,
  } = props;

  return (
    <div>
      {/* <div className="form-section">
        <div className="section-header">
          <h4>
            <i className="fa fa-list"></i>
            Feature Details
          </h4>
        </div> */}
      <div className="section-content">
        <div className="features-grid">
          {featureDetails.map((feature, index) => (
            <div className="feature-card" key={feature.id}>
              <div className="feature-checkbox">
                <input
                  type="checkbox"
                  id={`feature-${feature.id}`}
                  checked={feature.checked}
                  onChange={(e) => {
                    const updatedFeatures = [...featureDetails];
                    updatedFeatures[index].checked = e.target.checked;
                    if (
                      feature.label === "Talk later speciality" &&
                      !e.target.checked
                    ) {
                      updatedFeatures[index].input_value = [
                        { specialty: "", noOfCalls: "" },
                      ];
                    }
                    if (
                      feature.label === "Talk Later Doctor wise" &&
                      e.target.checked
                    ) {
                      updatedFeatures[index].input_value = [
                        { doctors: null, no_of_calls: "" },
                      ];
                    }
                    if (
                      feature.label === "Talk Later Doctor wise" &&
                      !e.target.checked
                    ) {
                      updatedFeatures[index].input_value = [];
                    }
                    if (feature.label === "Delivery" && !e.target.checked) {
                      handleAllCheckedFreeDelivery(false, index);
                    }
                    // if (feature.label === "Claim Module" && e.target.checked) {
                    //   // Prime claim defaults in a single state write to avoid race conditions

                    // }

                    setFeatureDetails(updatedFeatures);
                  }}
                />
                <label htmlFor={`feature-${feature.id}`}>{feature.label}</label>
              </div>
              {feature.label === "Talk later speciality" && feature.checked ? (
                <>
                  {feature.input_value.map((speciality, specIndex) => (
                    <div className="speciality-row" key={specIndex}>
                      <Select
                        placeholder="Select Specialities"
                        options={specialtyListOption}
                        className="speciality-select"
                        classNamePrefix="select"
                        value={speciality.specialty || null}
                        onChange={(selected) => {
                          onSpecialityChange(selected, index, specIndex);
                        }}
                      />
                      <FormControl
                        type="text"
                        placeholder="Enter number of calls"
                        className="form-control speciality-input"
                        value={speciality.noOfCalls}
                        onChange={(e) => {
                          onCallChange(e, index, specIndex);
                        }}
                        disabled={speciality.unlimited}
                      />
                      {/* add custom checkbox for unlimited calls */}
                      <CustomCheckbox
                        number={specIndex + 5000}
                        checked={speciality.unlimited || false}
                        onChange={(e) =>
                          onCallUnlimitedChange(e, index, specIndex)
                        }
                        label="Unlimited Calls"
                      />
                      <div className="speciality-actions">
                        <button
                          type="button"
                          className="speciality-btn speciality-close"
                          onClick={() => {
                            removeSpecialtyRow(index, specIndex);
                          }}
                        >
                          <i className="fa fa-close"></i>
                        </button>
                        {specIndex === feature.input_value.length - 1 && (
                          <button
                            type="button"
                            className="speciality-btn speciality-add"
                            onClick={() => {
                              addSpecialtyRow(index);
                            }}
                          >
                            Add
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              ) : feature.label === "Delivery" && feature.checked ? (
                <div className="delivery-block">
                  <div className="delivery-top">
                    <FormControl
                      type="text"
                      placeholder="No Of Free Delivery"
                      className="delivery-input"
                      value={noOfFreeDelivery || ""}
                      onChange={(e) => {
                        // only i want add positive number
                        const value = e.target.value;
                        if (value === "" || /^[0-9\b]+$/.test(value)) {
                          setNoOfFreeDelivery(value);
                          const updated = [...featureDetails];
                          updated[index].noOfFreeDelivery = value;
                          setFeatureDetails(updated);
                        }
                      }}
                    />
                    <FormControl
                      type="text"
                      placeholder="Enter the welcome note"
                      className="delivery-input"
                      value={deliveryWelcomeNote || ""}
                      onChange={(e) => {
                        setDeliveryWelcomeNote(e.target.value);
                        const updated = [...featureDetails];
                        updated[index].deliveryWelcomeNote = e.target.value;
                        setFeatureDetails(updated);
                      }}
                    />
                  </div>
                  {feature.input_value.map((option, dIdx) => {
                    const enabled =
                      option.enabled !== undefined && option.enabled !== null
                        ? option.enabled
                        : false;
                    const typeLabel =
                      option.type === "standard"
                        ? "Standard"
                        : option.type === "express"
                          ? "Express"
                          : option.type === "island_wide"
                            ? "Island Wide"
                            : option.type || `Option ${dIdx + 1}`;

                    const handleToggle = (checked) => {
                      const updated = [...featureDetails];
                      const item = { ...updated[index].input_value[dIdx] };
                      item.enabled = checked;
                      if (!checked) {
                        item.free = null;
                        item.discount = null;
                        item.base_price = null;
                      }
                      updated[index].input_value[dIdx] = item;
                      setFeatureDetails(updated);
                    };

                    const handleFieldChange = (key, value) => {
                      const updated = [...featureDetails];
                      const item = { ...updated[index].input_value[dIdx] };
                      item[key] = value;
                      item.enabled = true;
                      updated[index].input_value[dIdx] = item;
                      setFeatureDetails(updated);
                    };

                    return (
                      <div className="delivery-row" key={option.type || dIdx}>
                        <div className="delivery-header">
                          <label className="delivery-toggle">
                            <input
                              type="checkbox"
                              checked={enabled}
                              onChange={(e) => handleToggle(e.target.checked)}
                            />
                            <span className="delivery-toggle-text">
                              {typeLabel}
                            </span>
                          </label>
                        </div>
                        {enabled && (
                          <div className="delivery-fields">
                            <FormControl
                              type="text"
                              placeholder="No of Free"
                              value={
                                option.free !== undefined &&
                                option.free !== null
                                  ? option.free
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || /^[0-9\b]+$/.test(value)) {
                                  handleFieldChange("free", value);
                                }
                              }}
                              className="delivery-input"
                            />
                            <FormControl
                              type="text"
                              placeholder="Discount"
                              value={
                                option.discount !== undefined &&
                                option.discount !== null
                                  ? option.discount
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || /^[0-9\b]+$/.test(value)) {
                                  handleFieldChange("discount", value);
                                }
                              }}
                              className="delivery-input"
                            />
                            <FormControl
                              type="text"
                              placeholder="Base Price"
                              value={
                                option.base_price !== undefined &&
                                option.base_price !== null
                                  ? option.base_price
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || /^[0-9\b]+$/.test(value)) {
                                  handleFieldChange("base_price", value);
                                }
                              }}
                              className="delivery-input"
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : feature.label === "Partner & Coupon Management" &&
                feature.checked ? (
                <div className="partner-coupon-block">
                  {(() => {
                    const tierOptions = feature.tierOptions || [
                      { value: "platinum", label: "Platinum" },
                      { value: "gold", label: "Gold" },
                      { value: "silver", label: "Silver" },
                      { value: "browns", label: "Browns" },
                    ];
                    const rawSelectedCoupons = feature.selectedCoupons || [];

                    const toCouponDisplay = (item) => {
                      const id = item && item.id !== undefined ? item.id : item;
                      const match = couponList.find(
                        (c) => String(c.id) === String(id),
                      );
                      const label =
                        (match && (match.label || match.title)) ||
                        (item && (item.label || item.title)) ||
                        id;
                      const title =
                        (match && (match.title || match.label)) ||
                        (item && (item.title || item.label)) ||
                        label;
                      return { id, label, title };
                    };

                    const selectedCoupons =
                      rawSelectedCoupons.map(toCouponDisplay);

                    return (
                      <>
                        <div className="partner-row">
                          <select
                            className="form-control"
                            disabled={!feature.checked}
                            value={selectedTiers || ""}
                            onChange={(e) => onChangeTier(e, index)}
                          >
                            <option value="">Select Tier</option>
                            {tierOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>

                          <select
                            className="form-control"
                            value={selectedTags || ""}
                            onChange={(e) => onChangeTags(e)}
                          >
                            <option value="">Select Tag</option>
                            {tagListOption &&
                              tagListOption.map((opt, idx) => (
                                <option
                                  key={opt.value || idx}
                                  value={opt.value}
                                >
                                  {opt.label || opt.value}
                                </option>
                              ))}
                          </select>

                          <select
                            className="form-control"
                            disabled={!feature.checked}
                            defaultValue=""
                            onChange={(e) => onCouponAdd(e, index)}
                          >
                            <option value="">Select Coupons</option>
                            {couponList &&
                              couponList.map((opt, idx) => (
                                <option key={opt.id || idx} value={opt.id}>
                                  {opt.title || opt.label || opt.id}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="partner-chip-row">
                          {selectedCoupons.map((item) => (
                            <div className="partner-chip" key={item.id}>
                              <span className="partner-chip-text">
                                {item.title || item.label || item.id}
                              </span>
                              <button
                                type="button"
                                className="partner-chip-remove"
                                onClick={() => onRemoveCoupon(item.id, index)}
                                aria-label="Remove coupon"
                              >
                                x
                              </button>
                            </div>
                          ))}
                        </div>
                      </>
                    );
                  })()}
                </div>
              ) : feature.label === "MBE Groups" && feature.checked ? (
                <div className="mbe-groups-block">
                  {(() => {
                    const groups = Array.isArray(groupData) ? groupData : [];
                    const selectedGroups = Array.isArray(feature.value)
                      ? feature.value
                      : [];

                    return (
                      <>
                        <div className="partner-row">
                          <select
                            className="form-control"
                            disabled={!feature.checked}
                            defaultValue=""
                            onChange={(e) => onGroupAdd(e, index)}
                          >
                            <option value="">SELECT Group</option>
                            {groups.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.group_name ||
                                  option.label ||
                                  option.name ||
                                  option.id}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="partner-chip-row">
                          {selectedGroups.map((item) => (
                            <div
                              className="partner-chip"
                              key={item.id || item.group_name}
                            >
                              <span className="partner-chip-text">
                                {item.group_name ||
                                  item.label ||
                                  item.name ||
                                  item.id}
                              </span>
                              <button
                                type="button"
                                className="partner-chip-remove"
                                onClick={() => onGroupRemove(item.id, index)}
                                aria-label="Remove group"
                              >
                                x
                              </button>
                            </div>
                          ))}
                        </div>
                      </>
                    );
                  })()}
                </div>
              ) : feature.label === "Claim Module" && feature.checked ? (
                <div className="claim-module-block">
                  {(() => {
                    const claimTypeOptions = [
                      { value: "per_employee", label: "Per Employee" },
                      { value: "per_claim", label: "Per Claim" },
                    ];
                    const claimBillingCycleOptions = [
                      { value: "monthly", label: "Monthly" },
                      { value: "weekly", label: "Weekly" },
                    ];

                    const claimData = {
                      claimValue: feature.claimValue || "",
                      claimType: feature.claimType || "",
                      isUnlimitedClaim: feature.isUnlimitedClaim || false,
                      isSystemClaimAllowed:
                        feature.isSystemClaimAllowed || false,
                      isBankAccountNeeded: feature.isBankAccountNeeded || false,
                      claimBillingCycle: feature.claimBillingCycle || "",
                      opdIndividualPrice: feature.opdIndividualPrice || "",
                      poolValue: feature.poolValue || "",
                      opdFamilyPrice: feature.opdFamilyPrice || "",
                      pharma: feature.pharma || "",
                      lab: feature.lab || "",
                      consult: feature.consult || "",
                      hospital: feature.hospital || "",
                      isClaimMedicine: feature.isClaimMedicine || false,
                      isClaimLab: feature.isClaimLab || false,
                      isClaimRaya: feature.isClaimRaya || false,
                      isClaimTalkNow: feature.isClaimTalkNow || false,
                      isClaimTalkLater: feature.isClaimTalkLater || false,
                      isClaimTalkGlobal: feature.isClaimTalkGlobal || false,
                      isClaimEchanneling: feature.isClaimEchanneling || false,
                      isHospitalization: feature.isHospitalization || false,
                      isClaimFamily: feature.isClaimFamily || false,
                      isClaimMother: feature.isClaimMother || false,
                      isClaimFather: feature.isClaimFather || false,
                      isClaimSister: feature.isClaimSister || false,
                      isClaimBrother: feature.isClaimBrother || false,
                      isClaimSpouse: feature.isClaimSpouse || false,
                      isClaimChild: feature.isClaimChild || false,
                      ipdClaimValue: feature.ipdClaimValue || "",
                    };

                    return (
                      <>
                        <div className="claim-fields-grid">
                          <div className="claim-field-group">
                            <label className="claim-field-label">
                              Claim Allocation
                            </label>
                            <FormControl
                              disabled={claimData.isUnlimitedClaim}
                              placeholder="Claim Allocation"
                              type="text"
                              className="claim-input"
                              value={claimData.claimValue}
                              onChange={(e) => {
                                const re = /^[0-9\b]+$/;
                                if (
                                  e.target.value === "" ||
                                  re.test(e.target.value)
                                ) {
                                  updateClaimField(
                                    index,
                                    "claimValue",
                                    e.target.value,
                                  );
                                }
                              }}
                            />
                            {claimValueError && (
                              <div className="error-message">
                                {claimValueError}
                              </div>
                            )}
                          </div>

                          <div className="claim-field-group">
                            <label className="claim-field-label">
                              Claim Type
                            </label>
                            <Select
                              isDisabled={!feature.checked}
                              className="claim-select"
                              placeholder="Claim Type"
                              value={claimTypeOptions.find(
                                (opt) => opt.value === claimData.claimType,
                              )}
                              onChange={(selected) =>
                                updateClaimField(
                                  index,
                                  "claimType",
                                  selected.value,
                                )
                              }
                              options={claimTypeOptions}
                            />
                          </div>
                        </div>

                        <div className="claim-checkboxes-row">
                          <CustomCheckbox
                            number={feature.id + 888}
                            checked={claimData.isUnlimitedClaim}
                            onChange={(e) =>
                              toggleClaimCheckbox(
                                index,
                                "isUnlimitedClaim",
                                e.target.checked,
                              )
                            }
                            label="Unlimited Allocation"
                          />
                          <CustomCheckbox
                            number={feature.id + 887}
                            checked={claimData.isSystemClaimAllowed}
                            onChange={(e) =>
                              toggleClaimCheckbox(
                                index,
                                "isSystemClaimAllowed",
                                e.target.checked,
                              )
                            }
                            label="Allow System Claim"
                          />
                          <CustomCheckbox
                            number={feature.id + 886}
                            checked={claimData.isBankAccountNeeded}
                            onChange={(e) =>
                              toggleClaimCheckbox(
                                index,
                                "isBankAccountNeeded",
                                e.target.checked,
                              )
                            }
                            label="Bank Account Needed"
                          />
                        </div>

                        <div className="claim-fields-grid">
                          <div className="claim-field-group">
                            <label className="claim-field-label">
                              Billing Cycle
                            </label>
                            <Select
                              isDisabled={!feature.checked}
                              className="claim-select"
                              placeholder="Billing Cycle"
                              value={claimBillingCycleOptions.find(
                                (opt) =>
                                  opt.value == claimData.claimBillingCycle,
                              )}
                              onChange={(selected) =>
                                updateClaimField(
                                  index,
                                  "claimBillingCycle",
                                  selected.value,
                                )
                              }
                              options={claimBillingCycleOptions}
                            />
                          </div>

                          <div className="claim-field-group">
                            <label className="claim-field-label">
                              OPD Price
                            </label>
                            <FormControl
                              disabled={!feature.checked}
                              placeholder="Individual Price"
                              type="text"
                              className="claim-input"
                              value={claimData.opdIndividualPrice}
                              onChange={(e) => {
                                const re = /^[0-9\b]+$/;
                                if (
                                  e.target.value === "" ||
                                  re.test(e.target.value)
                                ) {
                                  updateClaimField(
                                    index,
                                    "opdIndividualPrice",
                                    e.target.value,
                                  );
                                }
                              }}
                            />
                          </div>

                          <div className="claim-field-group">
                            <label className="claim-field-label">
                              Pool Limit
                            </label>
                            <FormControl
                              disabled={!feature.checked}
                              placeholder="Pool Limit"
                              type="text"
                              className="claim-input"
                              value={claimData.poolValue}
                              onChange={(e) => {
                                const re = /^[0-9\b]+$/;
                                if (
                                  e.target.value === "" ||
                                  re.test(e.target.value)
                                ) {
                                  updateClaimField(
                                    index,
                                    "poolValue",
                                    e.target.value,
                                  );
                                }
                              }}
                            />
                          </div>

                          <div className="claim-field-group">
                            <label className="claim-field-label">
                              Family Allocation
                            </label>
                            <FormControl
                              disabled={
                                !feature.checked || !claimData.isClaimFamily
                              }
                              placeholder="Family Allocation"
                              type="text"
                              className="claim-input"
                              value={claimData.opdFamilyPrice}
                              onChange={(e) =>
                                updateClaimField(
                                  index,
                                  "opdFamilyPrice",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                        </div>

                        <div className="claim-section">
                          <label className="claim-section-label">
                            Manual Claim Features
                          </label>
                          <div className="claim-checkboxes-grid">
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 900}
                              checked={claimData.pharma === "Pharma"}
                              onChange={(e) =>
                                updateClaimField(
                                  index,
                                  "pharma",
                                  e.target.checked ? "Pharma" : "",
                                )
                              }
                              label="Pharma"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 90}
                              checked={claimData.lab === "Lab"}
                              onChange={(e) =>
                                updateClaimField(
                                  index,
                                  "lab",
                                  e.target.checked ? "Lab" : "",
                                )
                              }
                              label="Lab"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 91}
                              checked={claimData.consult === "Consult"}
                              onChange={(e) =>
                                updateClaimField(
                                  index,
                                  "consult",
                                  e.target.checked ? "Consult" : "",
                                )
                              }
                              label="Consult"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 92}
                              checked={claimData.hospital === "Hospital"}
                              onChange={(e) =>
                                updateClaimField(
                                  index,
                                  "hospital",
                                  e.target.checked ? "Hospital" : "",
                                )
                              }
                              label="Hospital"
                            />
                            {claimData.hospital === "Hospital" && (
                              <div className="claim-field-group">
                                <FormControl
                                  // disabled={claimData.isUnlimitedClaim}
                                  placeholder="IPD Claim Allocation"
                                  type="text"
                                  className="claim-input"
                                  value={claimData.ipdClaimValue || ""}
                                  onChange={(e) => {
                                    const re = /^[0-9\b]+$/;
                                    if (
                                      e.target.value === "" ||
                                      re.test(e.target.value)
                                    ) {
                                      updateClaimField(
                                        index,
                                        "ipdClaimValue",
                                        e.target.value,
                                      );
                                    }
                                  }}
                                />
                                {ipdClaimValueError && (
                                  <div className="error-message">
                                    {ipdClaimValueError}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="claim-section">
                          <label className="claim-section-label">
                            Claim Category
                          </label>
                          <div className="claim-checkboxes-grid">
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 799}
                              checked={claimData.isClaimMedicine}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isClaimMedicine",
                                  e.target.checked,
                                )
                              }
                              label="Medicine"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 802}
                              checked={claimData.isClaimLab}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isClaimLab",
                                  e.target.checked,
                                )
                              }
                              label="Lab"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 803}
                              checked={claimData.isClaimRaya}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isClaimRaya",
                                  e.target.checked,
                                )
                              }
                              label="Raya"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 804}
                              checked={claimData.isClaimTalkNow}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isClaimTalkNow",
                                  e.target.checked,
                                )
                              }
                              label="Talk Now"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 805}
                              checked={claimData.isClaimTalkLater}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isClaimTalkLater",
                                  e.target.checked,
                                )
                              }
                              label="Talk Later"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 806}
                              checked={claimData.isClaimTalkGlobal}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isClaimTalkGlobal",
                                  e.target.checked,
                                )
                              }
                              label="Talk Global"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 901}
                              checked={claimData.isClaimEchanneling}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isClaimEchanneling",
                                  e.target.checked,
                                )
                              }
                              label="E-Channeling"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 903}
                              checked={claimData.isHospitalization}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isHospitalization",
                                  e.target.checked,
                                )
                              }
                              label="Hospitalization"
                            />
                            <CustomCheckbox
                              disabled={!feature.checked}
                              number={feature.id + 809}
                              checked={claimData.isClaimFamily}
                              onChange={(e) =>
                                toggleClaimCheckbox(
                                  index,
                                  "isClaimFamily",
                                  e.target.checked,
                                )
                              }
                              label="Family"
                            />
                          </div>

                          {claimData.isClaimFamily && (
                            <div className="claim-family-section">
                              <label className="claim-subsection-label">
                                Select the beneficiary
                              </label>
                              <div className="claim-checkboxes-grid">
                                <CustomCheckbox
                                  disabled={!feature.checked}
                                  number={feature.id + 808}
                                  checked={claimData.isClaimMother}
                                  onChange={(e) =>
                                    toggleClaimCheckbox(
                                      index,
                                      "isClaimMother",
                                      e.target.checked,
                                    )
                                  }
                                  label="Mother"
                                />
                                <CustomCheckbox
                                  disabled={!feature.checked}
                                  number={feature.id + 807}
                                  checked={claimData.isClaimFather}
                                  onChange={(e) =>
                                    toggleClaimCheckbox(
                                      index,
                                      "isClaimFather",
                                      e.target.checked,
                                    )
                                  }
                                  label="Father"
                                />
                                <CustomCheckbox
                                  disabled={!feature.checked}
                                  number={feature.id + 810}
                                  checked={claimData.isClaimSister}
                                  onChange={(e) =>
                                    toggleClaimCheckbox(
                                      index,
                                      "isClaimSister",
                                      e.target.checked,
                                    )
                                  }
                                  label="Sister"
                                />
                                <CustomCheckbox
                                  disabled={!feature.checked}
                                  number={feature.id + 811}
                                  checked={claimData.isClaimBrother}
                                  onChange={(e) =>
                                    toggleClaimCheckbox(
                                      index,
                                      "isClaimBrother",
                                      e.target.checked,
                                    )
                                  }
                                  label="Brother"
                                />
                                <CustomCheckbox
                                  disabled={!feature.checked}
                                  number={feature.id + 812}
                                  checked={claimData.isClaimSpouse}
                                  onChange={(e) =>
                                    toggleClaimCheckbox(
                                      index,
                                      "isClaimSpouse",
                                      e.target.checked,
                                    )
                                  }
                                  label="Spouse"
                                />
                                <CustomCheckbox
                                  disabled={!feature.checked}
                                  number={feature.id + 813}
                                  checked={claimData.isClaimChild}
                                  onChange={(e) =>
                                    toggleClaimCheckbox(
                                      index,
                                      "isClaimChild",
                                      e.target.checked,
                                    )
                                  }
                                  label="Child"
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        {(claimData.isClaimTalkGlobal ||
                          claimData.isClaimTalkLater ||
                          claimData.isClaimTalkNow ||
                          claimData.isClaimRaya ||
                          claimData.isClaimLab ||
                          claimData.isClaimMedicine) && (
                          <div className="claim-policy-section">
                            <label className="claim-section-label">
                              Claim Policy Details
                            </label>
                            <Editor
                              editorState={
                                feature.claimPolicyDetails &&
                                feature.claimPolicyDetails.value
                              }
                              editorClassName="terms-editor"
                              onEditorStateChange={(editorState) => {
                                updatePolicyField(
                                  index,
                                  "medicine",
                                  editorState,
                                );
                              }}
                            />
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              ) : feature.label === "Talk Later Doctor wise" &&
                feature.checked ? (
                <>
                  {(Array.isArray(feature.input_value)
                    ? feature.input_value
                    : []
                  ).map((doctor, docIdx) => (
                    <div className="speciality-row" key={docIdx}>
                      <Select
                        placeholder="Select Doctor"
                        options={doctorListOption}
                        className="speciality-select"
                        classNamePrefix="select"
                        value={doctor.doctors || null}
                        onChange={(selected) =>
                          onDoctorChange(selected, index, docIdx)
                        }
                      />
                      <FormControl
                        type="text"
                        placeholder="Number of Calls"
                        className="form-control speciality-input"
                        value={doctor.no_of_calls || ""}
                        onChange={(e) => onDoctorCallChange(e, index, docIdx)}
                      />
                      <div className="speciality-actions">
                        <button
                          type="button"
                          className="speciality-btn speciality-close"
                          onClick={() => removeDoctorRow(index, docIdx)}
                        >
                          <i className="fa fa-close"></i>
                        </button>
                        {docIdx === (feature.input_value || []).length - 1 && (
                          <button
                            type="button"
                            className="speciality-btn speciality-add"
                            onClick={() => addDoctorRow(index)}
                          >
                            Add
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                feature.checked && (
                  <>
                    <div className="feature-input">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={feature.placeholder}
                        value={feature.input_value}
                        onChange={(e) => {
                          if (
                            e.target.value === "" ||
                            /^[0-9\b]+$/.test(e.target.value)
                          ) {
                            const updatedFeatures = [...featureDetails];
                            updatedFeatures[index].input_value = e.target.value;
                            setFeatureDetails(updatedFeatures);
                          }
                        }}
                      />
                    </div>
                    {feature.isFlashCredit !== undefined && (
                      <div className="flash-credit-control">
                        <label
                          className="flash-credit-toggle"
                          htmlFor={`featureFlashCredit-${feature.id + 1}`}
                          title="Mark as Flash Credit"
                        >
                          <input
                            type="checkbox"
                            id={`featureFlashCredit-${feature.id + 1}`}
                            checked={feature.isFlashCredit}
                            onChange={(e) => {
                              const updatedFeatures = [...featureDetails];
                              updatedFeatures[index].isFlashCredit =
                                e.target.checked;
                              setFeatureDetails(updatedFeatures);
                            }}
                            disabled={feature.unlimited}
                          />
                          <span
                            className="flash-credit-box"
                            aria-hidden="true"
                          />
                          <span className="flash-credit-text">
                            Flash Credit
                          </span>
                        </label>
                      </div>
                    )}
                    {feature.unlimited !== undefined && (
                      <div className="flash-credit-control">
                        <label
                          className="flash-credit-toggle"
                          htmlFor={`featureUnlimited-${feature.id + 2}`}
                          title="Mark as Flash Credit"
                        >
                          <input
                            type="checkbox"
                            id={`featureUnlimited-${feature.id + 2}`}
                            checked={feature.unlimited}
                            onChange={(e) => {
                              const updatedFeatures = [...featureDetails];
                              updatedFeatures[index].unlimited =
                                e.target.checked;
                              if (e.target.checked) {
                                updatedFeatures[index].input_value =
                                  "unlimited";
                              } else {
                                updatedFeatures[index].input_value = "";
                              }
                              setFeatureDetails(updatedFeatures);
                            }}
                            disabled={feature.isFlashCredit}
                          />
                          <span
                            className="flash-credit-box"
                            aria-hidden="true"
                          />
                          <span className="flash-credit-text">Unlimited</span>
                        </label>
                      </div>
                    )}
                  </>
                )
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
    // </div>
    // </div>
  );
};

export default CataloguePackageFeatureDetailsForm;
